// @flow
import * as React from 'react';
import {renderers} from '@markdoc/markdoc';
import * as components from 'docs/components';

// TODO: Remove when we can transform entire diagram Markdoc text --> React on client
export const renderMarkdocAsReact = (content: any): React.Node => {
  return renderers.react(content, React, {components});
};
